'use client';
import React from 'react';
import { Col, Container, Placeholder, Row } from 'react-bootstrap';

export default function DetailSkeleton() {
  return (
    <Container className="mt-5 mb-5">
      <Row>
        <Col xs={12} md={8}>
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ height: '540px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
        </Col>
        <Col xs={12} md={4}>
          <Placeholder xs={12} style={{ height: '170px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ height: '170px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ height: '170px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ height: '170px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
        </Col>
      </Row>
    </Container>
  );
}
